import { FC } from 'react';

import { Button, Typography } from '@mui/material';

import { Flex } from 'src/components/Flex';
import { useTransactionChargeContext } from 'src/contexts/TransactionChargeProvider';

interface UpdateTransactionPricing {
    onClose: () => void;
    valuesToUpdate: object;
}

export const UpdateTransactionPricing: FC<UpdateTransactionPricing> = ({ onClose }) => {
    const { selectedTransactionOfferId, refetchActiveTransactionOffers } =
        useTransactionChargeContext();

    const onSave = async () => {
        refetchActiveTransactionOffers && refetchActiveTransactionOffers();

        onClose();
    };

    return (
        <Flex
            flexDirection="column"
            height="100vh"
            width="100vw"
            justifyContent="center"
            alignItems="center"
        >
            <Flex
                alignSelf="center"
                maxWidth="400px"
                bgcolor="white"
                padding="16px"
                borderRadius="16px"
                flexDirection="column"
                gap="24px"
            >
                <Typography fontSize="20px" fontWeight="600">
                    Save Changes
                </Typography>
                <Typography
                    fontSize="16px"
                    fontWeight="500"
                >{`Please note, the changes you have made to this offer shall not affect any previous merchants/applications that are live or inflight. The system will duplicate the offer with the new values and create a new Offer and assign it a new offer ID and will auto assign it to all partners that had it before. The existing offer values will not be changed and will be assigned a historical offer ID for audit purposes. The historical offer ID will be 'Legacy - ${selectedTransactionOfferId}' and can still be found in the offer list`}</Typography>
                <Flex alignItems="center" gap="24px" flex={1} justifyContent="space-between">
                    <Button
                        variant="main"
                        sx={{ bgcolor: '#1d1d1b', opacity: 0.7, color: 'white' }}
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="main"
                        sx={{ bgcolor: '#1d1d1b', color: 'white' }}
                        onClick={onSave}
                    >
                        Save
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
};
